import {takeEvery} from 'redux-saga/effects'
import {
  ADD_RESOURCE_ARCHIVE_FOLDER,
  DELETE_RESOURCE_ARCHIVE_FOLDER,
  GET_RESOURCE_ARCHIVE_FOLDER,
  GET_RESOURCE_ARCHIVE_FOLDERS,
  UPDATE_RESOURCE_ARCHIVE_FOLDER,
} from 'setup/redux/Actions/ResourceArchiveFolder/ActionTypes/ApiActionTypes'

import fetchData from '../../SagaHelper'

function* dataSaga() {
  yield takeEvery(GET_RESOURCE_ARCHIVE_FOLDERS, fetchData)
  yield takeEvery(GET_RESOURCE_ARCHIVE_FOLDER, fetchData)
  yield takeEvery(ADD_RESOURCE_ARCHIVE_FOLDER, fetchData)
  yield takeEvery(UPDATE_RESOURCE_ARCHIVE_FOLDER, fetchData)
  yield takeEvery(DELETE_RESOURCE_ARCHIVE_FOLDER, fetchData)
}

export default dataSaga
